export enum PermissionEnum {
    WRITE = 'WRITE',
    READ = 'READ',
    NONE = 'NONE'
}